import React from 'react';
import { Svg, Path } from '@react-pdf/renderer';

const CheckboxChecked = () => (
  <Svg width="24" height="24" viewBox="0 0 24 24"><Path fill="black" d="M11 17l-5-5.299 1.399-1.43 3.574 3.736 6.572-7.007 1.455 1.403-8 8.597zm11-15v20h-20v-20h20zm2-2h-24v24h24v-24z"/></Svg>
);

export default CheckboxChecked;
